import Heart from './Heart';
import { IconProps } from './types';

const FullHeart = ({ color, dimension }: IconProps) =>
  Heart({ color, dimension, fill: color });

export default FullHeart;
